import * as React from "react";
import type { SVGProps } from "react";
const SvgLinkedin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 21v1a1 1 0 0 0 1-1zm-4 0h-1a1 1 0 0 0 1 1zm-4 0v1a1 1 0 0 0 1-1zm-4 0H9a1 1 0 0 0 1 1zM2 9V8a1 1 0 0 0-1 1zm4 0h1a1 1 0 0 0-1-1zm0 12v1a1 1 0 0 0 1-1zm-4 0H1a1 1 0 0 0 1 1zM16 9a5 5 0 0 1 3.535 1.464L20.95 9.05A7 7 0 0 0 16 7zm3.535 1.464A5 5 0 0 1 21 14h2a7 7 0 0 0-2.05-4.95zM21 14v7h2v-7zm1 6h-4v2h4zm-3 1v-7h-2v7zm0-7a3 3 0 0 0-.879-2.121l-1.414 1.414A1 1 0 0 1 17 14zm-.879-2.121A3 3 0 0 0 16 11v2a1 1 0 0 1 .707.293zM16 11a3 3 0 0 0-2.121.879l1.414 1.414A1 1 0 0 1 16 13zm-2.121.879A3 3 0 0 0 13 14h2a1 1 0 0 1 .293-.707zM13 14v7h2v-7zm1 6h-4v2h4zm-3 1v-7H9v7zm0-7a5 5 0 0 1 1.464-3.536L11.05 9.05A7 7 0 0 0 9 14zm1.464-3.536A5 5 0 0 1 16 9V7a7 7 0 0 0-4.95 2.05zM2 10h4V8H2zm3-1v12h2V9zm1 11H2v2h4zm-3 1V9H1v12zM5 4a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zM4 5a1 1 0 0 1-1-1H1a3 3 0 0 0 3 3zM3 4a1 1 0 0 1 1-1V1a3 3 0 0 0-3 3zm1-1a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3z"
    />
  </svg>
);
export default SvgLinkedin;
